module.exports = __webpack_public_path__ + "static/media/transfer_table.8a8cda08.svg";